<template>
  <div>
    <!-- <Header /> -->

    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div class="flex">
      <SideBar />

      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-x-auto overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div class="p-10 flex flex-col gap-5">
          <div
            class="flex flex-col-reverse items-end md:flex-row md:items-center md:justify-between gap-4"
          >
            <div class="flex-1">
              <h1
                class="text-textblues font-semibold text-sm break-words max-w-full sm:max-w-[500px] line-clamp-2"
              >
                {{ assignment_title }}
              </h1>
            </div>

            <router-link
              :to="{ name: 'GradeBook', query: { fromTab: 'assignment' } }"
              class="bg-blues hover:bg-hover text-white px-4 py-1.5 text-xs font-semibold rounded-2xl flex items-center justify-center w-fit"
            >
              ← Back
            </router-link>
          </div>

          <div class="flex flex-col md:flex-row gap-3 justify-end">
            <div class="flex flex-wrap gap-5 items-center">
              <div class="">
                <div class="relative w-full md:max-w-80">
                  <div
                    class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-4 w-4 text-gray-400"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                      />
                    </svg>
                  </div>
                  <input
                    type="text"
                    v-model="searching"
                    @input="getassignmentdetails(1)"
                    placeholder="Search..."
                    class="w-full rounded-xl border border-gray-200 bg-white pl-10 pr-10 py-2 text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                  />
                  <button
                    v-if="searching"
                    @click="clearSearch"
                    class="absolute inset-y-0 right-0 pr-3 flex items-center"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-4 w-4 text-gray-400 hover:text-gray-600"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>
              </div>

              <button
                @click="Assdownload()"
                :disabled="assignments.length === 0"
                :class="[
                  assignments.length > 0
                    ? 'bg-blues hover:bg-hover cursor-pointer text-white'
                    : 'bg-gray-100 cursor-not-allowed text-gray-500',
                ]"
                class=" md:w-auto justify-center rounded-2xl py-2 px-5 flex items-center gap-2 transition-all duration-200"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4"
                  />
                </svg>
                <p class="text-sm">Download</p>
              </button>
            </div>
          </div>
          <div>
            <div
              class="overflow-x-auto bg-white rounded-xl shadow-sm border border-[#e2e8f0] overflow-hidden"
            >
              <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-100 whitespace-nowrap">
                  <tr class="text-left text-white text-sm">
                    <th
                      class="px-6 py-4 text-textblues font-semibold border-b border-r"
                    >
                      S.No
                    </th>
                    <th
                      class="px-6 py-4 text-textblues font-semibold border-b border-r"
                    >
                      Name
                    </th>
                    <th
                      class="px-6 py-4 text-textblues font-semibold border-b border-r text-center"
                    >
                      Grade
                    </th>
                    <th
                      class="px-6 py-4 text-textblues font-semibold border-b border-r"
                    >
                      Complete Date
                    </th>
                  </tr>
                </thead>
                <tbody
                  v-if="assignments.length > 0"
                  class="divide-y divide-gray-100 text-sm whitespace-nowrap"
                >
                  <tr
                    v-for="(assignment, index) in assignments"
                    :key="index"
                    class="hover:bg-gray-50"
                  >
                    <td class="px-4 py-2 font-medium text-gray-800 border-r">
                      {{ (currentPage - 1) * pageSize + index + 1 }}
                    </td>
                    <td class="px-4 py-2 text-gray-700 border-r">
                      {{ assignment?.user?.display_name || "Na" }}
                    </td>
                    <td class="px-4 py-2 text-center text-gray-700 border-r">
                      {{ assignment.remark }}
                    </td>

                    <td class="px-4 py-2 text-gray-600">
                      {{ formatDate(assignment.created_at) }}
                    </td>
                  </tr>
                </tbody>
                <tr v-else>
                  <td colspan="11" class="px-6 py-3 text-center">
                    No Data Found
                  </td>
                </tr>
              </table>
            </div>

            <div
              v-if="total_count >= 11"
              class="flex flex-col sm:flex-row justify-center gap-3 mt-4 relative"
            >
              <!-- PAGE SIZE -->
              <div
                class="md:absolute md:left-3 md:top-2 flex gap-2 text-sm text-gray-600 justify-center items-center"
              >
                <span class="flex md:hidden">Rows per page:</span>
                <select
                  v-model="pageSize"
                  @change="onPageSizeChange"
                  class="border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option :value="10">10</option>
                  <option :value="20">20</option>
                  <option :value="50">50</option>
                  <option :value="100">100</option>
                </select>
              </div>

              <!-- PAGINATION -->
              <div class="flex justify-center">
                <Pagination
                  :totalPages="totalPages"
                  ref="studentPagination"
                  @page-changed="getassignmentdetails"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Instructor/Header.vue";
import SideBar from "@/components/Instructor/SideBar.vue";
import FlashMessage from "@/components/FlashMessage.vue";
import Pagination from "@/components/Pagination.vue";

import axios from "axios";
import { mapGetters } from "vuex";

export default {
  components: {
    Header,
    SideBar,
    FlashMessage,
    Pagination,
  },
  data() {
    return {
      userSelectList: [],

      messages: {
        text: "",
        type: "null",
      },
      loading: true,
      pageSize: 10,
      currentPage: 1,
      totalPages: 1,
      tab: "assignment",
      assignments: [],
      searching: "",
      total_count: 0,
    };
  },
  created() {
    this.getassignmentdetails(1);
  },

  props: ["assignment_id", "course_id", "assignment_title"],

  computed: {
    ...mapGetters(["userInfo"]),
  },

  methods: {
    clearSearch() {
      this.searching = "";
      this.getassignmentdetails(1);
    },
    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      return `${year}-${month}-${day}`;
    },
    onPageSizeChange() {
      this.currentPage = 1;
      this.$refs.studentPagination?.resetPage?.(); // reset to page 1 if your Pagination supports it
      this.getassignmentdetails(1);
    },

    async getassignmentdetails(page) {
      this.currentPage = page;
      await axios
        .get(
          `${process.env.VUE_APP_API}/student_assignment_drade/detail/?Key=${this.userInfo.token_key}&assignment_id=${this.assignment_id}&page=${page}&page_size=${this.pageSize}&verify_status=accepted`,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.totalPages = response.data.data?.total_page;
            this.total_count = response.data.data?.total;
            this.assignments = response.data.data?.data?.data || [];
          } else if (response.data.status == 400) {
            this.assignments = [];
          }
          this.loading = false;
        })
        .catch((error) => {
          console.error("Error:", error);
          this.assignments = [];
          this.loading = false;
        });
    },
    async Assdownload() {
      const url = `${process.env.VUE_APP_API}/student_assignment_drade/detail/?Key=${this.userInfo.token_key}&assignment_id=${this.assignment_id}&download=True&verify_status=accepted`;
      window.location.href = url;
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
